const getProductVariantAndColourWayIds = (state, id) => {
  const { colourWayId, variantId, productId } = state.savedItems.items.find(
    savedItem => savedItem.id === id
  );

  return { colourWayId, variantId, productId };
};

export default getProductVariantAndColourWayIds;
